import { type AnyAction } from '@reduxjs/toolkit';
import { type Persistor } from 'redux-persist';

import { type Store } from './types';

let _store: Store;
let _persistor: Persistor;

export const setStore = (store: Store): Store => {
  _store = store;
  return _store;
};

/**
 * TODO: consider deprecating, while considering the many ad use cases
 * prefer to encapsulate from an argument similar
 * to react middleware (http://redux.js.org/docs/advanced/Middleware.html)
 *
 * @returns {Store} our redux store singleton
 */
export const getStore = (): Store => {
  return _store;
};

export const setPersistor = (persistor: Persistor): void => {
  _persistor = persistor;
};

export const getPersistor = (): Persistor => {
  return _persistor;
};

export const dispatch = (action: AnyAction): void => {
  getStore()?.dispatch(action);
};
